import { useShowEveryXBusinessDays } from '../hooks/useShowEveryXBusinessDays';
/**
 * Component that will show its children every X business days.
 */
export const ShowEveryXBusinessDays = ({ children, businessDaysBetweenRequests, businessDaysBetweenDismiss, }) => {
    const { show: isNotRecentlySent, setLastDate: setLastSent } = useShowEveryXBusinessDays('lastCsatSent', businessDaysBetweenRequests);
    const { show: isNotRecentlyDismissed, setLastDate: setLastDismiss } = useShowEveryXBusinessDays('lastCsatDismiss', businessDaysBetweenDismiss);
    if (!isNotRecentlyDismissed || !isNotRecentlySent) {
        return null;
    }
    else {
        return children({ setLastSent, setLastDismiss });
    }
};
